import { message } from "antd";
import { ReceiptLongOutlined } from "@mui/icons-material";
import { FormActions } from "../../components/common/FormActions";
import {
  StatusTags,
  TransactionStatusTag,
} from "../../components/common/registerUtils";
import {
  createCustomAction,
  createViewAction,
  downloadThroughAnchorLink,
  formatCurrency,
  formatDateTime,
} from "../../utils/helpers";
import { BASE_API_URL } from "../../config";
import { URL_QR_CODE_PAYMENT } from "../../utils/urls";

const url = URL_QR_CODE_PAYMENT;

export const useQRcodePayments = () => {
  const generateReceipt = (item: any) => {
    const hide = message.loading("Generating receipt...", 0);

    downloadThroughAnchorLink(
      `${BASE_API_URL}qrcode-payments/${item?.id}/generate-payment-receipt`,
      `receipt-${item?.transaction_reference || item?.id}.pdf`,
    )
      .catch(() => {
        message.error("Failed to generate receipt. Please try again.");
      })
      .finally(() => hide());
  };

  const createReceiptAction = (item: any) =>
    createCustomAction("", "Generate Receipt", ReceiptLongOutlined, () =>
      generateReceipt(item),
    );

  const tableColumns = () => [
    { id: "customer_name", header: "Customer name", filter: { type: "text" } },
    { id: "merchant_name", header: "Merchant name", filter: { type: "text" } },

    { id: "phone_number", header: "Phone number", filter: { type: "text" } },
    {
      id: "transaction_amount",
      header: "Transaction amount",
      filter: { type: "number" },
    },
    {
      id: "transaction_reference",
      header: "Transaction reference",
      filter: { type: "text" },
    },
    {
      id: "transaction_date",
      header: "Transaction date",
      filter: { type: "date", single: true },
    },
    { id: "status", header: "Status", filter: { type: "text" } },
    { id: "narration", header: "Narration", filter: { type: "text" } },
    { id: "provider_name", header: "Provider", filter: { type: "text" } },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        transaction_amount: formatCurrency(item?.transaction_amount),
        status: <TransactionStatusTag status={item?.status} />,
        transaction_date: formatDateTime(item?.transaction_date),
        actions: (
          <FormActions
            actions={[
              createViewAction(url, item?.id),
              createReceiptAction(item),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "QR Code Payment Details",
          fields: {
            customer_name: item?.customer_name,
            phone_number: item?.phone_number,
            transaction_amount: formatCurrency(item?.transaction_amount),
            transaction_reference: item?.transaction_reference,
            created_by: item?.created_by,
            qr_code: item?.qr_code,
            transaction_date: formatDateTime(item?.transaction_date),
            status: <StatusTags status={item?.status} />,
            narration: item?.narration,
            created_at: formatDateTime(item?.created_at),
            provider_name: item?.provider_name,
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
  };
};
